module.exports = __webpack_public_path__ + "static/media/youtube-clone.7357ae15.png";